<div class="container">
  <div class="text-center">
    <div class="faq-title"><p i18n="@@faqsTitle">FAQs</p></div>
    <div class="page-subtitle">
      <p i18n="@@faqsSubTitle">Find Answers to Your Questions: Everything You Need to Know About Using Akl Bayti</p>
    </div>
  </div>
  <div class="faqs-container">
    <div class="faq-sections-container">
      <div class="faq-section" *ngIf="!isMobileView"><p i18n="@@sectionsTitle">Sections</p></div>
      <div class="faq-category" *ngFor="let faq of faqsList; let x = index;"
           [ngClass]="selectedFaqIndex === x ? 'has-focus' : 'no-focus'"
           (click)="loadQuestions(x)">
        <p>{{ faq.mainCategory }}</p>
      </div>
    </div>
    <div class="w-100">
      <div class="faq-item-container" *ngFor="let faq of faqsList[selectedFaqIndex].subList; let i = index;">
        <a class="nav-link collapsed" data-bs-toggle="collapse" [attr.data-bs-target]="'#question'+i">
          <p>{{ faq.question }}</p>
        </a>
        <div class="collapse" [attr.id]="'question'+i" aria-expanded="true">
          <div class="nav-item">
            <div class="faq-answer"><p>{{ faq.answer }}</p></div>
          </div>
        </div>
      </div>
    </div>
  </div>
  <div class="contact-us" routerLink="/contact-us">
    <primary-button
      title="Contact Us">
    </primary-button>
  </div>
</div>
